import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useEffect, useState } from 'react'
import Paginate from '../pagination/paginate'
import {
	appCreateSanstha,
	appDeleteSanstha,
	appGetAllSanstha,
	appUpdateSanstha,
	uploadSansthaImage,
} from '../../store/sanstha'
import { EditorState, convertToRaw } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import { ContentState } from 'draft-js'
import htmlToDraft from 'html-to-draftjs'
import draftToHtml from 'draftjs-to-html'
import Select from 'react-select'
import ImageUpload from '../ImageUpload'
import swal from 'sweetalert'
import axios from 'axios'
import PostPreview from '../PostPreview/PostPreview'
import { sansthaExportColumns } from '../../config/exportColumns/sansthaExportColumns'
import ExportButton from '../../common/ExportButton'
import { fetchPincodeDetails } from '../../utils/Function'

function Sanstha({ sansthaList, hubDetails, sanstha, sansthaPage, setSansthaPage }) {
	const dispatch = useDispatch()

	const { id } = useParams()
	const sansthapaginate = useSelector(state => state.sansthaReducer.paginate)

	const [showModal, setShowModal] = useState(false)
	const [editMode, setEditMode] = useState(false)
	const [editSansthaId, setEditSansthaId] = useState(null)
	const isdeleted = useSelector(state => state?.sansthaReducer?.isdeleted)
	const [editorValues, setValues] = useState(EditorState.createEmpty())
	const [selectedSansthaType, setSelectedSansthaType] = useState('')
	const [otherSansthaType, setOtherSansthaType] = useState('')
	const [selectedAct, setSelectedAct] = useState('')
	const [otherAct, setOtherAct] = useState('')
	const [showVerificationAlert, setShowVerificationAlert] = useState(false)
	const [areaList, setAreaList] = useState([])
	const [selectedArea, setSelectedArea] = useState(null)
	const [missingDocs, setMissingDocs] = useState([])

	const sansthaData = [
		{
			sansthaType: 'Not registered(AOP)',
			acts: ['NA'],
		},
		{
			sansthaType: 'Charitable, Religious Trust',
			acts: [
				'Indian Trusts Act, 1882',
				'Maharashtra Public Trust Act 1950 (earlier Bombay Public Trusts Act, 1950)',
				'Gujarat Public Trusts Act, 2011 (earlier Bombay Public Trusts Act, 1950)',
				'THE RAJASTHAN PUBLIC TRUST ACT, 1959',
				'Andhra Pradesh Charitable and Hindu Religious Institutions and Endowments Act, 1987',
				'Bihar Hindu Religious Trusts Act, 1950',
				'Karnataka Hindu Religious Institutions and Charitable Endowments Act, 1997',
				'Kerala Travancore-Cochin Hindu Religious Institutions Act, 1950',
				'Orissa Hindu Religious Endowments Act, 1951',
				'Tamil Nadu Hindu Religious and Charitable Endowments Act, 1959',
				'Uttar Pradesh Charitable Endowments (Extension of Powers) Act, 1950',
				'Charitable Endowments (U.P. Amendment) Act, 1952',
				'Religious Endowments (Uttar Pradesh Amendment) Act, 1951',
				'Uttar Pradesh Hindu Religious Institutions (Prevention of Dissipation of Properties) (Repeal) Act, 2000',
				'The Madhya Pradesh Public Trusts Act, 1951',
			],
		},
		{
			sansthaType: 'NGO',
			acts: ['COMPANIES ACT 2013'],
		},
		{
			sansthaType: 'Company',
			acts: ['COMPANIES ACT, 1956'],
		},
		{
			sansthaType: 'Society',
			acts: [
				'Societies Registration Act, 1860',
				'Multi-State Societies Registration Bill, 2012',
				'The Karnataka Societies Registration Act, 1960',
				'The West Bengal Societies Registration Act, 1961',
				'The Tamil Nadu Societies Registration Act, 1975',
				'Manipur Societies Registration Act, 1989',
				'The Jammu – Kashmir Societies Registration Act, 1998',
				'Societies Registration (Uttar Pradesh Amendment) Act, 2000',
			],
		},
		{
			sansthaType: 'Registered (AOP)',
			acts: [
				'Registration Act, 1908',
				'Indian Stamp Act, 1899',
				'The Madhya Pradesh Registration Adhiniyam, 1961',
			],
		},
		{
			sansthaType: 'Trust, Wakf',
			acts: [
				'Mussalman Wakf Act, 1923',
				'Mussalman Wakf Validating Act,1913',
				'Wakf Act, 1995',
				'Mussalman Wakf Validating Act, 1930',
			],
		},
	]

	const actOptions = (() => {
		const found = sansthaData.find(item => item.sansthaType === selectedSansthaType)
		const acts = found?.acts || []
		return selectedSansthaType ? [...acts, 'Other'] : []
	})()

	const sansthaFormik = useFormik({
		initialValues: {
			name: '',
			description: '',
			hub: id,
			image: '',
			sansthaPincode: '',
			sansthaArea: '',
			sansthaState: '',
			sansthaDistrict: '',
			sansthaBlock: '',
			sansthaPlaceAddress: '',
			active: false,
			verified: false,
			aadhaarnumber: '',
			pancardnumber: '',
			sansthaPlace: '',
			isRegistered: false,
			registrationNumber: '',
			registrationDate: '',

			sansthaPanCardNumber: '',
			authorityLetters: '',
			acceptingnewmember: true,
			aadhaarFront: '',
			aadhaarBack: '',
			panCardImage: '',
			sansthaCertificate: '',
			sansthaPanCardImage: '',
			sansthaType:
				selectedSansthaType === 'Other' ? otherSansthaType : selectedSansthaType?.sansthaType,
			Act: selectedAct === 'Other' ? otherAct : selectedAct,
			verifiedAadharCard: false,
			verifiedPancard: false,
			verifiedRegistrationNumber: false,
			verifiedSansthaPancard: false,
			verifiedAuthorityLetter: false,
		},
		validationSchema: Yup.object({
			name: Yup.string().required('Name is required'),
			description: Yup.string()
				.transform(value => {
					if (!value) return ''
					return value
						.replace(/<[^>]+>/g, '')
						.replace(/&nbsp;/gi, '')
						.replace(/\s+/g, '')
						.trim()
				})
				.test('is-not-empty', 'Description is Required', value => value && value.length > 0)
				.required('Description is Required'),
			image: Yup.string()
				.required('Image is required')
				.test('is-valid-url', 'Invalid image', value => {
					return value && value !== '/img/default-placeholder.jpg'
				}),
			sansthaPincode: Yup.string()
				.required('Pincode is required')
				.matches(/^[0-9]{6}$/, 'Pincode must be a 6-digit number'),

			sansthaArea: Yup.string().required('Area is required'),

			sansthaState: Yup.string().required('State is required'),

			sansthaDistrict: Yup.string().required('District is required'),

			sansthaBlock: Yup.string().required('Taluka is required'),

			sansthaPlaceAddress: Yup.string().required('Sanstha Address is required'),

			active: Yup.boolean(),
			verified: Yup.boolean(),

			aadhaarnumber: Yup.string()
				.required('Aadhaar card number is required')
				.matches(/^[2-9]{1}[0-9]{11}$/, 'Invalid Aadhaar card number'),
			pancardnumber: Yup.string()
				.required('PAN card number is required')
				.matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Enter a valid PAN card number'),
			aadhaarFront: Yup.string()
				.required('Image is required')
				.test('is-valid-url', 'Invalid image', value => {
					return value && value !== '/img/default-placeholder.jpg'
				}),
			aadhaarBack: Yup.string()
				.required('Image is required')
				.test('is-valid-url', 'Invalid image', value => {
					return value && value !== '/img/default-placeholder.jpg'
				}),
			panCardImage: Yup.string()
				.required('Image is required')
				.test('is-valid-url', 'Invalid image', value => {
					return value && value !== '/img/default-placeholder.jpg'
				}),

			isRegistered: Yup.boolean(),

			registrationNumber: Yup.string().when('isRegistered', {
				is: true,
				then: Yup.string().required('Registration Number is required'),
				otherwise: Yup.string().notRequired(),
			}),

			registrationDate: Yup.string().when('isRegistered', {
				is: true,
				then: Yup.string().required('Registration Date is required'),
				otherwise: Yup.string().notRequired(),
			}),

			sansthaType: Yup.string().when('isRegistered', {
				is: true,
				then: Yup.string().required('Sanstha Type is required'),
				otherwise: Yup.string().notRequired(),
			}),

			Act: Yup.string().when('isRegistered', {
				is: true,
				then: Yup.string().required('Sanstha Act is required'),
				otherwise: Yup.string().notRequired(),
			}),

			sansthaPanCardNumber: Yup.string().when('isRegistered', {
				is: true,
				then: Yup.string()
					.required('PAN card number is required')
					.matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Enter a valid PAN card number'),
				otherwise: Yup.string().notRequired(),
			}),

			authorityLetters: Yup.string().when('isRegistered', {
				is: true,
				then: Yup.string()
					.required('Image is required')
					.test('is-valid-url', 'Invalid image', value => {
						return value && value !== '/img/default-placeholder.jpg'
					}),
				otherwise: Yup.string().notRequired(),
			}),

			sansthaCertificate: Yup.string().when('isRegistered', {
				is: true,
				then: Yup.string()
					.required('Image is required')
					.test('is-valid-url', 'Invalid image', value => {
						return value && value !== '/img/default-placeholder.jpg'
					}),
				otherwise: Yup.string().notRequired(),
			}),

			sansthaPanCardImage: Yup.string().when('isRegistered', {
				is: true,
				then: Yup.string()
					.required('Image is required')
					.test('is-valid-url', 'Invalid image', value => {
						return value && value !== '/img/default-placeholder.jpg'
					}),
				otherwise: Yup.string().notRequired(),
			}),
		}),
		onSubmit: async values => {
			//	console.log(values)
			const temp_obj = {
				name: values?.name,
				image: values?.image,
				hub: typeof values?.hub === 'object' ? values?.hub?._id : values?.hub,
				description: values?.description,
				sansthaPincode: values?.sansthaPincode,
				sansthaArea: values?.sansthaArea,
				sansthaState: values?.sansthaState,
				sansthaDistrict: values?.sansthaDistrict,
				sansthaBlock: values?.sansthaBlock,
				sansthaCountry: values?.sansthaCountry,
				sansthaPlaceAddress: values?.sansthaPlaceAddress,
				active: values?.active,
				verified: values?.verified,
				sansthaPlace: values?.sansthaPlace,
				isRegistered: values?.isRegistered,
				aadhaarnumber: values?.aadhaarnumber,
				pancardnumber: values?.pancardnumber,
				aadhaarFront: values?.aadhaarFront,
				aadhaarBack: values?.aadhaarBack,
				panCardImage: values?.panCardImage,

				registrationNumber: values?.registrationNumber,
				registrationDate: values?.registrationDate,
				sansthaType: values?.sansthaType,
				Act: values?.Act,
				sansthaPanCardNumber: values?.sansthaPanCardNumber,
				authorityLetters: values?.authorityLetters,
				sansthaCertificate: values?.sansthaCertificate,
				sansthaPanCardImage: values?.sansthaPanCardImage,
				acceptingnewmember: values?.acceptingnewmember,

				verifiedAadharCard: values?.verifiedAadharCard,
				verifiedPancard: values?.verifiedPancard,
				verifiedRegistrationNumber: values?.verifiedRegistrationNumber,
				verifiedSansthaPancard: values?.verifiedSansthaPancard,
			}
			//console.log(temp_obj)

			const filtered_obj = Object.fromEntries(
				Object.entries(temp_obj).filter(
					([key, value]) =>
						value !== '' && value !== null && value !== undefined && key !== 'navigate',
				),
			)

			if (editMode && editSansthaId) {
				dispatch(appUpdateSanstha({ ...filtered_obj, id: editSansthaId })).then(() => {
					dispatch(appGetAllSanstha({ page: 1, limit: 10, hub: id }))
				})
			} else {
				dispatch(appCreateSanstha(filtered_obj)).then(() => {
					dispatch(appGetAllSanstha({ page: 1, limit: 10, hub: id }))
				})
			}
			setShowModal(false)
			setEditMode(false)
			setEditSansthaId(null)
			sansthaFormik.resetForm()
		},
	})

	const handlePincodeBlur = async e => {
		sansthaFormik.handleBlur(e)

		const pincode = e.target.value
		//console.log(pincode)
		if (pincode && pincode.length === 6) {
			const postOffices = await fetchPincodeDetails(pincode)
			setAreaList(postOffices)
		}
	}

	useEffect(() => {
		const fetchAreaOnEdit = async () => {
			if (sanstha && id) {
				const selectedsanstha = Array.isArray(sanstha) ? sanstha.find(c => c._id === id) : sanstha

				if (selectedsanstha?.sansthaPincode) {
					const postOffices = await fetchPincodeDetails(selectedsanstha.sansthaPincode)
					setAreaList(postOffices)
				}
			}
		}

		fetchAreaOnEdit()
	}, [sanstha, id])

	const checkAllDocumentsVerified = () => {
		const missing = []

		if (!sansthaFormik.values.verifyAadharFront) {
			missing.push('Admin user Aadhar card front')
		}

		if (!sansthaFormik.values.verifiedPancard) {
			missing.push('Admin user PAN card')
		}

		if (sansthaFormik.values.isRegistered) {
			if (!sansthaFormik.values.authorityLetters) {
				missing.push('Authority Letter not uploaded')
			}

			if (!sansthaFormik.values.verifiedAuthorityLetter) {
				missing.push('Authority Letter not verified')
			}

			if (!sansthaFormik.values.sansthaPanCardImage) {
				missing.push('Sanstha PAN Card not uploaded')
			}

			if (!sansthaFormik.values.verifiedSansthaPancard) {
				missing.push('Sanstha PAN Card not verified')
			}

			if (!sansthaFormik.values.sansthaCertificate) {
				missing.push('Sanstha Certificate not uploaded')
			}

			if (!sansthaFormik.values.verifiedRegistrationNumber) {
				missing.push('Sanstha Certificate not verified')
			}
		}

		setMissingDocs(missing)

		return missing.length === 0
	}
	const handleEditSanstha = async sanstha => {
		//	console.log(sanstha)
		setEditMode(true)
		setEditSansthaId(sanstha._id)

		let postOffices = []
		if (sanstha?.sansthaPincode) {
			postOffices = await fetchPincodeDetails(String(sanstha.sansthaPincode))
			setAreaList(postOffices || [])
		} else {
			setAreaList([])
		}

		if (sanstha.description) {
			const blocksFromHtml = htmlToDraft(sanstha.description)
			if (blocksFromHtml) {
				const { contentBlocks, entityMap } = blocksFromHtml
				const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap)
				setValues(EditorState.createWithContent(contentState))
			}
		} else {
			setValues(EditorState.createEmpty())
		}

		sansthaFormik.setValues({
			name: sanstha.name,
			description: sanstha.description,
			hub: typeof sanstha.hub === 'string' ? sanstha.hub : sanstha?.hub?._id,
			image: sanstha.image,
			sansthaPincode: sanstha.sansthaPincode,
			sansthaArea: sanstha.sansthaArea,
			sansthaState: sanstha.sansthaState,
			sansthaDistrict: sanstha.sansthaDistrict,
			sansthaBlock: sanstha.sansthaBlock,
			sansthaPlaceAddress: sanstha.sansthaPlaceAddress,
			active: sanstha.active,
			verified: sanstha.verified,
			aadhaarnumber: sanstha.aadhaarnumber,
			pancardnumber: sanstha.pancardnumber,
			sansthaPlace: sanstha.sansthaPlace,
			isRegistered: sanstha.isRegistered,
			registrationNumber: sanstha.registrationNumber,
			registrationDate: sanstha.registrationDate,
			sansthaType: sanstha.sansthaType,
			Act: sanstha.Act,
			sansthaPanCardNumber: sanstha.sansthaPanCardNumber,
			authorityLetters: sanstha.authorityLetters,
			acceptingnewmember: sanstha?.acceptingnewmember,
			aadhaarFront: sanstha.aadhaarFront,
			aadhaarBack: sanstha.aadhaarBack,
			panCardImage: sanstha.panCardImage,
			sansthaCertificate: sanstha.sansthaCertificate,
			sansthaPanCardImage: sanstha.sansthaPanCardImage,
			verifiedAadharCard: sanstha.verifiedAadharCard,
			verifiedPancard: sanstha.verifiedPancard,
			verifiedRegistrationNumber: sanstha.verifiedRegistrationNumber,
			verifiedSansthaPancard: sanstha.verifiedSansthaPancard,
		})

		if (postOffices?.length && sanstha?.sansthaArea) {
			const matched = postOffices.find(a => a.Name?.trim() === sanstha.sansthaArea?.trim())
			if (matched) {
				sansthaFormik.setFieldValue('sansthaArea', matched.Name)
				sansthaFormik.setFieldValue('sansthaState', matched.State || '')
				sansthaFormik.setFieldValue('sansthaDistrict', matched.District || '')
				sansthaFormik.setFieldValue('sansthaBlock', matched.Block || '')
			}
		}
		setShowModal(true)
	}

	const onEditorStateChange = editorState => {
		sansthaFormik.setFieldValue(
			'description',
			draftToHtml(convertToRaw(editorState.getCurrentContent())),
		)
		setValues(editorState)
	}

	const populateData = () => {
		if (sansthaList) {
			const selectedsanstha = Array.isArray(sansthaList)
				? sansthaList.find(c => c._id === editSansthaId)
				: sansthaList
			if (selectedsanstha?.description) {
				const blocksFromHtml = htmlToDraft(selectedsanstha?.description)
				const { contentBlocks, entityMap } = blocksFromHtml
				const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap)
				setValues(EditorState.createWithContent(contentState))
			}
		}
	}
	useEffect(() => {
		populateData()
	}, [sansthaList])

	useEffect(() => {
		if (isdeleted) {
			dispatch(appGetAllSanstha({ page: 1, limit: 10, hub: id }))
		}
	}, [isdeleted, dispatch, id])

	const handleDeleteSanstha = id => {
		swal({
			title: 'Are you sure?',
			text: 'You want to delete this sanstha?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(willDelete => {
			if (willDelete) {
				dispatch(appDeleteSanstha(id))
				dispatch(appGetAllSanstha({ page: 1, limit: 10, hub: id }))
			}
		})
	}

	const handleAddNewSanstha = () => {
		setEditMode(false)
		setEditSansthaId(null)
		sansthaFormik.resetForm()
		sansthaFormik.setValues({
			name: '',
			description: '',
			hub: id,
			image: '',
			sansthaPincode: '',
			sansthaArea: '',
			sansthaState: '',
			sansthaDistrict: '',
			sansthaBlock: '',
			sansthaPlaceAddress: '',
			active: false,
			verified: false,
			aadhaarnumber: '',
			pancardnumber: '',
			sansthaPlace: '',
			isRegistered: false,
			registrationNumber: '',
			registrationDate: '',

			sansthaPanCardNumber: '',
			authorityLetters: '',
			acceptingnewmember: true,
			aadhaarFront: '',
			aadhaarBack: '',
			panCardImage: '',
			sansthaCertificate: '',
			sansthaPanCardImage: '',
			sansthaType:
				selectedSansthaType === 'Other' ? otherSansthaType : selectedSansthaType?.sansthaType,
			Act: selectedAct === 'Other' ? otherAct : selectedAct,
			verifiedAadharCard: false,
			verifiedPancard: false,
			verifiedRegistrationNumber: false,
			verifiedSansthaPancard: false,
		})
		setValues(EditorState.createEmpty())
		setShowModal(true)
	}

	return (
		<>
			<div>
				<div className="mb-3 mr-2 d-flex justify-content-between align-items-center">
					<h4 className="ml-2">Total Sanstha: {sansthaList?.length || 0}</h4>

					<div className="d-flex gap-2">
						<ExportButton
							fetchAction={params =>
								dispatch(
									appGetAllSanstha({
										...params,
										page: 1,
										limit: 100000,
										hub: id,
										loading: false,
									}),
								)
							}
							columns={sansthaExportColumns}
							fileName="Sanstha_List"
							sheetName="Sanstha"
							buttonText="Export Sanstha"
							buttonClass="btn btn-success"
						/>

						<button
							className="btn btn-primary"
							style={{ marginLeft: '10px' }}
							onClick={handleAddNewSanstha}
						>
							<i className="far fa-plus"></i> Add New Sanstha
						</button>
					</div>
				</div>

				<div className="table-responsive">
					<table className="table table-bordered table-hover">
						<thead className="">
							<tr>
								<th></th>
								<th>Sanstha</th>
								<th data-column-id="received" data-order="desc">
									Community & Caste
								</th>
								<th data-column-id="received" data-order="desc">
									Total Members
								</th>
								<th data-column-id="received" data-order="desc">
									Language
								</th>
								<th data-column-id="received" data-order="desc">
									Religion
								</th>
								<th data-column-id="received" data-order="desc">
									Admin
								</th>
								<th data-column-id="received" data-order="desc">
									Sanstha Type
								</th>
								<th data-column-id="received" data-order="desc">
									Sanstha Act
								</th>
								<th data-column-id="received" data-order="desc">
									Registered
								</th>
								<th data-column-id="received" data-order="desc">
									Active
								</th>
								<th data-column-id="received" data-order="desc">
									verified
								</th>
								<th data-column-id="commands" data-formatter="commands" data-sortable="false">
									<div></div>
								</th>
							</tr>
						</thead>
						<tbody>
							{sanstha?.length > 0 ? (
								sanstha.map((value, index) => (
									<tr key={index}>
										<td>{index + 1}</td>
										<td
											style={{
												maxWidth: '100px',
												wordWrap: 'break-word',
												whiteSpace: 'normal',
											}}
										>
											<PostPreview value={value?.image} />

											{value?.name}
										</td>
										<td
											style={{
												maxWidth: '100px',
												wordWrap: 'break-word',
												whiteSpace: 'normal',
											}}
										>
											<span>{value?.hub?.name}</span>
											<br />
											<small>{value?.caste?.name}</small>
										</td>
										<td>{value?.users.length}</td>
										<td style={{ textTransform: 'capitalize' }}>
											{value?.language?.map((lang, i) => (
												<span key={i}>
													{lang.name}
													{i < value.language.length - 1 ? ', ' : ''}
												</span>
											))}
										</td>

										<td style={{ textTransform: 'capitalize' }}>{value?.religion?.name}</td>
										<td>
											{value?.admin?.firstName} {value?.admin?.lastName}
											<br />
											<small>{value?.admin?.mobile}</small>
											<br />
											<small>
												{value?.adminJoinedDate
													? new Date(value.adminJoinedDate).toLocaleDateString('en-US', {
															year: 'numeric',
															month: 'short',
															day: 'numeric',
													  })
													: '-'}
											</small>
										</td>

										<td
											style={{
												maxWidth: '150px',
												wordWrap: 'break-word',
												whiteSpace: 'normal',
											}}
										>
											{value?.sansthaType}
										</td>
										<td
											style={{
												maxWidth: '150px',
												wordWrap: 'break-word',
												whiteSpace: 'normal',
											}}
										>
											{value?.Act}
										</td>
										<td>
											{value?.registrationNumber}
											<br />
											{value?.registrationDate && (
												<small>
													{new Date(value?.registrationDate).toLocaleDateString('en-US', {
														year: 'numeric',
														month: 'short',
														day: 'numeric',
													})}
												</small>
											)}
										</td>

										<td>
											{value?.active ? (
												<span className="badge badge-success">Active</span>
											) : (
												<span className="badge badge-danger">Inactive</span>
											)}
										</td>
										<td>
											{value?.verified ? (
												<>
													<img
														src="/img/check.png"
														alt="Verified"
														title="Verified"
														height={30}
														width={30}
													/>
												</>
											) : (
												<>
													<img
														src="/img/uncheck.jpeg"
														alt="Not Verified"
														title="Not Verified"
														height={30}
														width={30}
													/>
												</>
											)}
										</td>
										<td>
											<button
												className="btn btn-sm btn-primary mr-2"
												title="Edit"
												onClick={() => handleEditSanstha(value)}
											>
												<i className="far fa-edit"></i>
											</button>
											<button
												className="btn btn-sm btn-danger"
												title="Delete"
												onClick={() => handleDeleteSanstha(value?._id)}
											>
												<i className="far fa-trash-alt"></i>
											</button>
										</td>
									</tr>
								))
							) : (
								<tr>
									<td colSpan="7" className="text-center">
										No sanstha data available
									</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>
				{sansthapaginate && (
					<Paginate paginate={sansthapaginate} page={sansthaPage} setPage={setSansthaPage} />
				)}

				{showModal && (
					<div
						className="modal fade show"
						style={{
							display: 'block',
							backgroundColor: 'rgba(0,0,0,0.5)',
							marginTop: '35px',
						}}
					>
						<div className="modal-dialog modal-lg">
							<div className="modal-content">
								<div className="modal-header">
									<h5 className="modal-title">
										{editMode ? 'Edit Sanstha' : 'Create New Sanstha'}
									</h5>
									<button
										type="button"
										className="close"
										onClick={() => {
											setShowModal(false)
											setEditMode(false)
											setEditSansthaId(null)
											sansthaFormik.resetForm()
										}}
									>
										<span>&times;</span>
									</button>
								</div>
								<div className="modal-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
									<form onSubmit={sansthaFormik.handleSubmit}>
										<div className="row">
											<div className="col-md-6">
												<div className="form-group">
													<label>Community *</label>
													<Select
														name="_id"
														options={[
															{
																value: id,
																label: hubDetails?.name,
															},
														]}
														onChange={option => {
															sansthaFormik.setFieldValue('hub', option?.value)
														}}
														className="basic-multi-select"
														classNamePrefix="select"
														value={[
															{
																value: id,
																label: hubDetails?.name,
															},
														]}
														placeholder="Select.."
														isDisabled={true}
													/>
													{sansthaFormik.touched.hub && sansthaFormik.errors.hub ? (
														<div style={{ color: 'red' }}>{sansthaFormik.errors.hub}</div>
													) : null}
												</div>
											</div>

											<div className="col-md-6">
												<ImageUpload
													uploadFunction={uploadSansthaImage}
													fieldName="image"
													value={sansthaFormik.values.image}
													onChange={value => sansthaFormik.setFieldValue('image', value.url)}
													error={
														sansthaFormik.touched.image && sansthaFormik.errors.image
															? sansthaFormik.errors.image
															: null
													}
												/>
											</div>
										</div>
										<div className="row">
											<div className="col-md-12">
												<div className="form-group">
													<label>Sanstha Name *</label>
													<input
														className="form-control"
														name="name"
														type="text"
														onChange={sansthaFormik.handleChange}
														onBlur={sansthaFormik.handleBlur}
														value={sansthaFormik.values.name}
													/>
													{sansthaFormik.touched.name && sansthaFormik.errors.name ? (
														<div style={{ color: 'red' }}>{sansthaFormik.errors.name}</div>
													) : null}
												</div>
											</div>
											<div className="col-md-12">
												<div className="form-group">
													<label>Description *</label>
													<Editor
														editorClassName="form-control"
														editorState={editorValues}
														onEditorStateChange={onEditorStateChange}
														editorStyle={{ height: 300 }}
													/>

													{sansthaFormik.touched.description && sansthaFormik.errors.description ? (
														<div style={{ color: 'red' }}>{sansthaFormik.errors.description}</div>
													) : null}
												</div>
											</div>
										</div>

										<div className="row" style={{ padding: '0 0 15px 0' }}>
											<div className="col-md-6 mb-3">
												<label>
													Pincode <span className="text-danger">*</span>
												</label>
												<input
													className="form-control"
													name="sansthaPincode"
													type="number"
													onChange={sansthaFormik.handleChange}
													onBlur={handlePincodeBlur}
													value={sansthaFormik.values.sansthaPincode}
												/>
												{sansthaFormik.touched.sansthaPincode &&
												sansthaFormik.errors.sansthaPincode ? (
													<div className="text-danger">{sansthaFormik.errors.sansthaPincode}</div>
												) : null}
											</div>

											<div className="col-md-6 mb-3">
												<label>Select Area</label>
												<select
													className="form-control"
													name="sansthaArea"
													onChange={e => {
														const selected = areaList.find(a => a.Name === e.target.value)
														setSelectedArea(selected)
														sansthaFormik.setFieldValue('sansthaArea', e.target.value)
														sansthaFormik.setFieldValue('sansthaState', selected?.State || '')
														sansthaFormik.setFieldValue('sansthaDistrict', selected?.District || '')
														sansthaFormik.setFieldValue('sansthaBlock', selected?.Block || '')
													}}
													value={sansthaFormik.values.sansthaArea || ''}
												>
													<option value="">Select Area</option>
													{areaList.map(area => (
														<option key={area.Name} value={area.Name}>
															{area.Name}
														</option>
													))}
												</select>
												{sansthaFormik.touched.sansthaArea && sansthaFormik.errors.sansthaArea && (
													<div className="text-danger">{sansthaFormik.errors.sansthaArea}</div>
												)}
											</div>

											<div className="col-md-6 mb-3">
												<label>State</label>
												<input
													className="form-control"
													name="sansthaState"
													type="text"
													onChange={sansthaFormik.handleChange}
													onBlur={sansthaFormik.handleBlur}
													value={sansthaFormik.values.sansthaState}
												/>
												{sansthaFormik.touched.sansthaState &&
													sansthaFormik.errors.sansthaState && (
														<div className="text-danger">{sansthaFormik.errors.sansthaState}</div>
													)}
											</div>

											<div className="col-md-6 mb-3">
												<label>District</label>
												<input
													className="form-control"
													name="sansthaDistrict"
													type="text"
													onChange={sansthaFormik.handleChange}
													onBlur={sansthaFormik.handleBlur}
													value={sansthaFormik.values.sansthaDistrict}
												/>
												{sansthaFormik.touched.sansthaDistrict &&
													sansthaFormik.errors.sansthaDistrict && (
														<div className="text-danger">
															{sansthaFormik.errors.sansthaDistrict}
														</div>
													)}
											</div>

											<div className="col-md-6 mb-3">
												<label>Taluka</label>
												<input
													className="form-control"
													name="sansthaBlock"
													type="text"
													onChange={sansthaFormik.handleChange}
													onBlur={sansthaFormik.handleBlur}
													value={sansthaFormik.values.sansthaBlock}
												/>
												{sansthaFormik.touched.sansthaBlock &&
													sansthaFormik.errors.sansthaBlock && (
														<div className="text-danger">{sansthaFormik.errors.sansthaBlock}</div>
													)}
											</div>

											<div className="col-md-12 mb-3">
												<label>
													Sanstha Address <span className="text-danger">*</span>
												</label>
												<input
													className="form-control"
													name="sansthaPlaceAddress"
													type="text"
													onChange={sansthaFormik.handleChange}
													onBlur={sansthaFormik.handleBlur}
													value={sansthaFormik.values.sansthaPlaceAddress}
												/>
												{sansthaFormik.touched.sansthaPlaceAddress &&
													sansthaFormik.errors.sansthaPlaceAddress && (
														<div className="text-danger">
															{sansthaFormik.errors.sansthaPlaceAddress}
														</div>
													)}
											</div>
										</div>

										<div className="row" style={{ padding: '0 0 15px 0' }}>
											<div className="col-md-6">
												<div className="form-group">
													<label>
														Admin user Aadhar card number <span style={{ color: 'red' }}>*</span>
													</label>
													<input
														className="form-control"
														name="aadhaarnumber"
														type="text"
														onChange={e => {
															const numericValue = e.target.value.replace(/\D/g, '')
															sansthaFormik.setFieldValue('aadhaarnumber', numericValue)
														}}
														onBlur={sansthaFormik.handleBlur}
														value={sansthaFormik.values.aadhaarnumber}
													/>
													{sansthaFormik.touched.aadhaarnumber &&
													sansthaFormik.errors.aadhaarnumber ? (
														<div style={{ color: 'red' }}>{sansthaFormik.errors.aadhaarnumber}</div>
													) : null}
												</div>
											</div>
											<div className="col-md-6">
												<div className="form-group">
													<label>
														Admin user PAN card number <span style={{ color: 'red' }}>*</span>
													</label>

													<input
														className="form-control"
														name="pancardnumber"
														type="text"
														onChange={e => {
															const upperCaseValue = e.target.value.toUpperCase()
															sansthaFormik.setFieldValue('pancardnumber', upperCaseValue)
														}}
														onBlur={sansthaFormik.handleBlur}
														value={sansthaFormik.values.pancardnumber}
													/>
													{sansthaFormik.touched.pancardnumber &&
													sansthaFormik.errors.pancardnumber ? (
														<div style={{ color: 'red' }}>{sansthaFormik.errors.pancardnumber}</div>
													) : null}
												</div>
											</div>
										</div>

										<div className="row">
											<div className="col-md-12">
												<div className="" style={{ width: '100%' }}>
													<div className="card">
														<h4 className="mb-3">Sanstha Documents </h4>

														<table className="table table-bordered">
															<thead
																style={{
																	backgroundColor: '#f5f5f5',
																	color: '#191717',
																}}
															>
																<tr style={{ fontWeight: 'bold' }}>
																	<th style={{ width: '20%', color: '#474040' }}>Document Name</th>
																	<th style={{ width: '40%', color: '#474040' }}>
																		Upload / Preview
																	</th>
																	<th style={{ width: '15%', color: '#474040' }}>Download</th>
																	<th style={{ width: '15%', color: '#474040' }}>Verified</th>
																</tr>
															</thead>
															<tbody>
																<tr>
																	<td>
																		Admin user Aadhar card front Image{' '}
																		<span style={{ color: 'red' }}>*</span>
																	</td>
																	<td>
																		<ImageUpload
																			uploadFunction={uploadSansthaImage}
																			fieldName="aadhaarFront"
																			value={sansthaFormik.values.aadhaarFront}
																			onChange={value =>
																				sansthaFormik.setFieldValue('aadhaarFront', value.url)
																			}
																			label=""
																			error={
																				sansthaFormik.touched.aadhaarFront &&
																				sansthaFormik.errors.aadhaarFront
																					? sansthaFormik.errors.aadhaarFront
																					: null
																			}
																			icon={<i className="fa fa-upload"></i>}
																		/>
																	</td>
																	<td style={{ textAlign: 'center' }}>
																		{sansthaFormik.values.aadhaarFront && (
																			<a
																				href={sansthaFormik.values.aadhaarFront}
																				target="_blank"
																				download
																				className="btn btn-outline-secondary btn-sm"
																			>
																				<i className="fa fa-download"></i>
																			</a>
																		)}
																	</td>
																	<td style={{ textAlign: 'center' }}>
																		<div className="custom-control custom-switch">
																			<input
																				type="checkbox"
																				className="custom-control-input"
																				id="verifyAadharFront"
																				checked={sansthaFormik.values.verifyAadharFront}
																				onChange={() =>
																					sansthaFormik.setFieldValue(
																						'verifyAadharFront',
																						!sansthaFormik.values.verifyAadharFront,
																					)
																				}
																			/>
																			<label
																				className="custom-control-label"
																				htmlFor="verifyAadharFront"
																			></label>
																		</div>
																	</td>
																</tr>

																<tr>
																	<td>
																		Admin user Aadhar card back Image{' '}
																		<span style={{ color: 'red' }}>*</span>
																	</td>
																	<td>
																		<ImageUpload
																			uploadFunction={uploadSansthaImage}
																			fieldName="aadhaarBack"
																			value={sansthaFormik.values.aadhaarBack}
																			onChange={value =>
																				sansthaFormik.setFieldValue('aadhaarBack', value.url)
																			}
																			label=""
																			error={
																				sansthaFormik.touched.aadhaarBack &&
																				sansthaFormik.errors.aadhaarBack
																					? sansthaFormik.errors.aadhaarBack
																					: null
																			}
																			icon={<i className="fa fa-upload"></i>}
																		/>
																	</td>
																	<td style={{ textAlign: 'center' }}>
																		{sansthaFormik.values.aadhaarBack && (
																			<a
																				href={sansthaFormik.values.aadhaarBack}
																				target="_blank"
																				download
																				className="btn btn-outline-secondary btn-sm"
																			>
																				<i className="fa fa-download"></i>
																			</a>
																		)}
																	</td>
																	<td></td>
																</tr>

																<tr>
																	<td>
																		Admin user PAN card Image{' '}
																		<span style={{ color: 'red' }}>*</span>
																	</td>
																	<td>
																		<ImageUpload
																			uploadFunction={uploadSansthaImage}
																			fieldName="panCardImage"
																			value={sansthaFormik.values.panCardImage}
																			onChange={value =>
																				sansthaFormik.setFieldValue('panCardImage', value.url)
																			}
																			label=""
																			error={
																				sansthaFormik.touched.panCardImage &&
																				sansthaFormik.errors.panCardImage
																					? sansthaFormik.errors.panCardImage
																					: null
																			}
																			icon={<i className="fa fa-upload"></i>}
																		/>
																	</td>
																	<td style={{ textAlign: 'center' }}>
																		{sansthaFormik.values.panCardImage && (
																			<a
																				href={sansthaFormik.values.panCardImage}
																				target="_blank"
																				download
																				className="btn btn-outline-secondary btn-sm"
																			>
																				<i className="fa fa-download"></i>
																			</a>
																		)}
																	</td>
																	<td style={{ textAlign: 'center' }}>
																		<div className="custom-control custom-switch">
																			<input
																				type="checkbox"
																				className="custom-control-input"
																				id="verifiedPancard"
																				checked={sansthaFormik.values.verifiedPancard}
																				onChange={() =>
																					sansthaFormik.setFieldValue(
																						'verifiedPancard',
																						!sansthaFormik.values.verifiedPancard,
																					)
																				}
																			/>
																			<label
																				className="custom-control-label"
																				htmlFor="verifiedPancard"
																			></label>
																		</div>
																	</td>
																</tr>
															</tbody>
														</table>
													</div>
												</div>
												<div className="form-group d-flex align-items-center">
													<label className="mr-3 mb-1" htmlFor="active">
														Make this Sanstha Active{' '}
														<small style={{ color: 'red' }}>
															{' '}
															(Active sanstha will be visible to users)
														</small>
													</label>
													<div className="custom-control custom-switch">
														<input
															type="checkbox"
															className="custom-control-input"
															id="active"
															checked={sansthaFormik.values.active}
															onChange={() =>
																sansthaFormik.setFieldValue('active', !sansthaFormik.values.active)
															}
														/>
														<label className="custom-control-label" htmlFor="active"></label>
													</div>
												</div>

												<div className="form-group d-flex align-items-center">
													<label
														className="mr-3 mb-0"
														htmlFor="durationSwitch"
														style={{ fontSize: '18px' }}
													>
														Is this Sanstha is Registered ?
													</label>
													<div className="custom-control custom-switch">
														<input
															type="checkbox"
															className="custom-control-input"
															id="durationSwitch"
															checked={sansthaFormik.values.isRegistered}
															onChange={() =>
																sansthaFormik.setFieldValue(
																	'isRegistered',
																	!sansthaFormik.values.isRegistered,
																)
															}
														/>
														<label
															className="custom-control-label"
															htmlFor="durationSwitch"
														></label>
													</div>
												</div>

												{sansthaFormik.values.isRegistered && (
													<div className="" style={{ width: '100%' }}>
														<div className="card">
															<table className="table table-bordered">
																<thead
																	style={{
																		backgroundColor: '#f5f5f5',
																		color: '#191717',
																	}}
																>
																	<tr style={{ fontWeight: 'bold' }}>
																		<th style={{ width: '20%', color: '#474040' }}>
																			Document Name
																		</th>
																		<th style={{ width: '40%', color: '#474040' }}>Upload</th>
																		<th style={{ width: '15%', color: '#474040' }}>Download</th>
																		<th style={{ width: '15%', color: '#474040' }}>Verified</th>
																	</tr>
																</thead>
																<tbody>
																	<tr>
																		<td>
																			Authority Letter <span style={{ color: 'red' }}>*</span>
																		</td>
																		<td>
																			<ImageUpload
																				uploadFunction={uploadSansthaImage}
																				fieldName="authorityLetters"
																				value={sansthaFormik.values.authorityLetters}
																				onChange={value =>
																					sansthaFormik.setFieldValue('authorityLetters', value.url)
																				}
																				label=""
																				error={
																					sansthaFormik.touched.authorityLetters &&
																					sansthaFormik.errors.authorityLetters
																						? sansthaFormik.errors.authorityLetters
																						: null
																				}
																				icon={<i className="fa fa-upload"></i>}
																			/>
																		</td>
																		<td>
																			{sansthaFormik.values.authorityLetters && (
																				<a
																					href={sansthaFormik.values.authorityLetters}
																					target="_blank"
																					download
																					className="btn btn-outline-secondary btn-sm"
																				>
																					<i className="fa fa-download"></i>
																				</a>
																			)}
																		</td>
																		<td style={{ textAlign: 'center' }}>
																			<div className="custom-control custom-switch">
																				<input
																					type="checkbox"
																					className="custom-control-input"
																					id="verifiedAuthorityLetter"
																					checked={sansthaFormik.values.verifiedAuthorityLetter}
																					onChange={() =>
																						sansthaFormik.setFieldValue(
																							'verifiedAuthorityLetter',
																							!sansthaFormik.values.verifiedAuthorityLetter,
																						)
																					}
																				/>
																				<label
																					className="custom-control-label"
																					htmlFor="verifiedAuthorityLetter"
																				></label>
																			</div>
																		</td>
																	</tr>

																	<tr>
																		<td>
																			Sanstha Pan card
																			<span style={{ color: 'red' }}>*</span>
																		</td>
																		<td>
																			<ImageUpload
																				uploadFunction={uploadSansthaImage}
																				fieldName="sansthaPanCardImage"
																				value={sansthaFormik.values.sansthaPanCardImage}
																				onChange={value =>
																					sansthaFormik.setFieldValue(
																						'sansthaPanCardImage',
																						value.url,
																					)
																				}
																				label=""
																				error={
																					sansthaFormik.touched.sansthaPanCardImage &&
																					sansthaFormik.errors.sansthaPanCardImage
																						? sansthaFormik.errors.sansthaPanCardImage
																						: null
																				}
																				icon={<i className="fa fa-upload"></i>}
																			/>
																		</td>
																		<td>
																			{sansthaFormik.values.sansthaPanCardImage && (
																				<a
																					href={sansthaFormik.values.sansthaPanCardImage}
																					target="_blank"
																					download
																					className="btn btn-outline-secondary btn-sm"
																				>
																					<i className="fa fa-download"></i>
																				</a>
																			)}
																		</td>
																		<td>
																			<div className="col-md-4 text-end">
																				<div className="form-check form-switch">
																					<div className="form-group d-flex align-items-center">
																						<div className="custom-control custom-switch">
																							<input
																								type="checkbox"
																								className="custom-control-input"
																								id="verifiedSansthaPancard"
																								checked={
																									sansthaFormik.values.verifiedSansthaPancard
																								}
																								onChange={() =>
																									sansthaFormik.setFieldValue(
																										'verifiedSansthaPancard',
																										!sansthaFormik.values.verifiedSansthaPancard,
																									)
																								}
																							/>
																							<label
																								className="custom-control-label"
																								htmlFor="verifiedSansthaPancard"
																							></label>
																						</div>
																					</div>
																				</div>
																			</div>
																		</td>
																	</tr>

																	<tr>
																		<td>
																			Sanstha Certificate <span style={{ color: 'red' }}>*</span>
																		</td>
																		<td>
																			<ImageUpload
																				uploadFunction={uploadSansthaImage}
																				fieldName="sansthaCertificate"
																				value={sansthaFormik.values.sansthaCertificate}
																				onChange={value =>
																					sansthaFormik.setFieldValue(
																						'sansthaCertificate',
																						value.url,
																					)
																				}
																				label=""
																				error={
																					sansthaFormik.touched.sansthaCertificate &&
																					sansthaFormik.errors.sansthaCertificate
																						? sansthaFormik.errors.sansthaCertificate
																						: null
																				}
																				icon={<i className="fa fa-upload"></i>}
																			/>
																		</td>
																		<td>
																			{sansthaFormik.values.sansthaCertificate && (
																				<a
																					href={sansthaFormik.values.sansthaCertificate}
																					target="_blank"
																					download
																					className="btn btn-outline-secondary btn-sm"
																				>
																					<i className="fa fa-download"></i>
																				</a>
																			)}
																		</td>
																		<td>
																			<div className="col-md-4 text-end">
																				<div className="form-check form-switch">
																					<div className="form-group d-flex align-items-center">
																						<div className="custom-control custom-switch">
																							<input
																								type="checkbox"
																								className="custom-control-input"
																								id="verifiedRegistrationNumber"
																								checked={
																									sansthaFormik.values.verifiedRegistrationNumber
																								}
																								onChange={() =>
																									sansthaFormik.setFieldValue(
																										'verifiedRegistrationNumber',
																										!sansthaFormik.values
																											.verifiedRegistrationNumber,
																									)
																								}
																							/>
																							<label
																								className="custom-control-label"
																								htmlFor="verifiedRegistrationNumber"
																							></label>
																						</div>
																					</div>
																				</div>
																			</div>
																		</td>
																	</tr>
																</tbody>
															</table>
														</div>
													</div>
												)}
											</div>
										</div>

										{sansthaFormik.values.isRegistered && (
											<>
												<div className="row" style={{ padding: '0 0 15px 0' }}>
													<div className="col-md-6">
														<div className="form-group">
															<label>
																Registration Number <span style={{ color: 'red' }}>*</span>
															</label>

															<input
																className="form-control"
																name="registrationNumber"
																type="text"
																onChange={sansthaFormik.handleChange}
																onBlur={sansthaFormik.handleBlur}
																value={sansthaFormik.values.registrationNumber}
															/>
															{sansthaFormik.touched.registrationNumber &&
															sansthaFormik.errors.registrationNumber ? (
																<div style={{ color: 'red' }}>
																	{sansthaFormik.errors.registrationNumber}
																</div>
															) : null}
														</div>
													</div>
													<div className="col-md-6">
														<div className="form-group">
															<label>
																Sanstha Type <span style={{ color: 'red' }}>*</span>
															</label>
															<select
																className="form-control"
																name="sansthaType"
																value={selectedSansthaType}
																onChange={e => {
																	const value = e.target.value
																	setSelectedSansthaType(value)
																	setSelectedAct('')
																	setOtherSansthaType('')
																	sansthaFormik.setFieldValue('sansthaType', value)
																	sansthaFormik.setFieldTouched('sansthaType', true)
																}}
																onBlur={sansthaFormik.handleBlur}
															>
																<option value="">Select Sanstha Type</option>
																{sansthaData.map(type => (
																	<option key={type.sansthaType} value={type.sansthaType}>
																		{type.sansthaType}
																	</option>
																))}
																<option value="Other">Other</option>
															</select>

															{selectedSansthaType === 'Other' && (
																<input
																	className="form-control mt-2"
																	placeholder="Enter other Sanstha Type"
																	value={otherSansthaType}
																	onChange={e => {
																		setOtherSansthaType(e.target.value)
																		sansthaFormik.setFieldValue('sansthaType', e.target.value)
																	}}
																/>
															)}
														</div>
													</div>
												</div>
												<div className="row" style={{ padding: '0 0 15px 0' }}>
													<div className="col-md-6">
														<div className="form-group">
															<label>
																Sanstha Act <span style={{ color: 'red' }}>*</span>
															</label>
															<select
																className="form-control"
																name="Act"
																value={selectedAct}
																onChange={e => {
																	const value = e.target.value
																	setSelectedAct(value)
																	setOtherSansthaType('')
																	sansthaFormik.setFieldValue('Act', value)
																}}
															>
																<option value="">Select Act</option>
																{actOptions.map((act, idx) => (
																	<option key={idx} value={act}>
																		{act}
																	</option>
																))}
															</select>

															{selectedAct === 'Other' && (
																<input
																	className="form-control mt-2"
																	placeholder="Enter other Act"
																	value={otherAct}
																	onChange={e => {
																		setOtherAct(e.target.value)
																		sansthaFormik.setFieldValue('Act', e.target.value)
																	}}
																/>
															)}
														</div>
													</div>
													<div className="col-md-6">
														<div className="form-group">
															<label>
																Date of registration <span style={{ color: 'red' }}>*</span>
															</label>

															<input
																type="date"
																className="form-control"
																value={sansthaFormik.values.registrationDate || ''}
																onChange={e => {
																	const rawValue = e.target.value
																	if (!rawValue) {
																		sansthaFormik.setFieldValue('registrationDate', '')
																		return
																	}

																	const dateObj = new Date(rawValue)
																	if (isNaN(dateObj.getTime())) return

																	sansthaFormik.setFieldValue('registrationDate', rawValue)
																}}
															/>
															{sansthaFormik.touched.registrationDate &&
															sansthaFormik.errors.registrationDate ? (
																<div style={{ color: 'red' }}>
																	{sansthaFormik.errors.registrationDate}
																</div>
															) : null}
														</div>
													</div>

													<div className="col-md-6">
														<div className="form-group">
															<label>
																Sanstha Pan Card Number <span style={{ color: 'red' }}>*</span>{' '}
															</label>

															<input
																className="form-control"
																name="sansthaPanCardNumber"
																type="text"
																onChange={e => {
																	const upperCaseValue = e.target.value.toUpperCase()
																	sansthaFormik.setFieldValue(
																		'sansthaPanCardNumber',
																		upperCaseValue,
																	)
																}}
																onBlur={sansthaFormik.handleBlur}
																value={sansthaFormik.values.sansthaPanCardNumber}
															/>
															{sansthaFormik.touched.sansthaPanCardNumber &&
															sansthaFormik.errors.sansthaPanCardNumber ? (
																<div style={{ color: 'red' }}>
																	{sansthaFormik.errors.sansthaPanCardNumber}
																</div>
															) : null}
														</div>
													</div>
												</div>
											</>
										)}

										<div className="form-group d-flex align-items-center">
											<label className="mr-3 mb-0" htmlFor="durationSwitch">
												Have you Verified All the Documents ?
											</label>
											<div className="custom-control custom-switch">
												<input
													type="checkbox"
													className="custom-control-input"
													id="verified"
													checked={sansthaFormik.values.verified}
													onChange={() => {
														if (!sansthaFormik.values.verified) {
															const isValid = checkAllDocumentsVerified()

															if (!isValid) {
																setShowVerificationAlert(true)
																return
															}
														}

														sansthaFormik.setFieldValue('verified', !sansthaFormik.values.verified)
													}}
												/>
												<label className="custom-control-label" htmlFor="verified"></label>
											</div>
										</div>

										<div className="form-group d-flex align-items-center">
											<label className="mr-3 mb-0" htmlFor="durationSwitch">
												Accepting New Member
											</label>
											<div className="custom-control custom-switch">
												<input
													type="checkbox"
													className="custom-control-input"
													id="acceptingnewmember"
													checked={sansthaFormik.values.acceptingnewmember}
													onChange={() =>
														sansthaFormik.setFieldValue(
															'acceptingnewmember',
															!sansthaFormik.values.acceptingnewmember,
														)
													}
												/>
												<label
													className="custom-control-label"
													htmlFor="acceptingnewmember"
												></label>
											</div>
										</div>

										<div className="modal-footer">
											<button
												className="btn btn-labeled btn-success"
												type="button"
												onClick={async () => {
													const errors = await sansthaFormik.validateForm()

													if (Object.keys(errors).length > 0) {
														const allFields = Object.keys(sansthaFormik.initialValues)
														const touchedFields = {}
														allFields.forEach(field => {
															touchedFields[field] = true
														})
														sansthaFormik.setTouched(touchedFields)
														return
													}

													sansthaFormik.handleSubmit()
												}}
											>
												<span className="btn-label">
													<i className="fa fa-check"></i>
												</span>
												{editMode ? 'Update' : 'Create'}
											</button>

											<button
												className="btn btn-labeled btn-secondary ml-2"
												type="button"
												onClick={() => {
													setShowModal(false)
													setEditMode(false)
													setEditSansthaId(null)
													sansthaFormik.resetForm()
												}}
											>
												<span className="btn-label">
													<i className="fa fa-times"></i>
												</span>
												Cancel
											</button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
			{showVerificationAlert && (
				<div
					className="modal"
					style={{
						display: 'block',
						backgroundColor: 'rgba(0,0,0,0.6)',
					}}
				>
					<div className="modal-dialog modal-dialog-centered">
						<div className="modal-content" style={{ borderRadius: '10px' }}>
							<div className="modal-header" style={{ backgroundColor: '#dc3545', color: '#fff' }}>
								<h5 className="modal-title">⚠ Verification Required</h5>
								<button
									type="button"
									className="close"
									style={{ color: '#fff' }}
									onClick={() => setShowVerificationAlert(false)}
								>
									&times;
								</button>
							</div>

							<div className="modal-body">
								<p>Please complete the following before verification:</p>

								<ul>
									{missingDocs.map((doc, i) => (
										<li key={i} style={{ color: 'red' }}>
											{doc}
										</li>
									))}
								</ul>
							</div>

							<div className="modal-footer">
								<button className="btn btn-danger" onClick={() => setShowVerificationAlert(false)}>
									OK
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	)
}
export default Sanstha
